import IntakeIntroStep, { IIntakeIntroStepPageContent } from './IntakeIntroStep.component';
import IntakeIntroStepPage from './IntakeIntroStep.page';

export default IntakeIntroStepPage;

export { IntakeIntroStep };
export type { IIntakeIntroStepPageContent };
